"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var hash_1 = require("../functional/hash");

var comparators_1 = require("../functional/comparators");
/**
 * Entry for mapping.
 *
 * @author Jeongho Nam <http://samchon.org>
 */


var Entry =
/** @class */
function () {
  /**
   * Intializer Constructor.
   *
   * @param first The first, key element.
   * @param second The second, mapped element.
   */
  function Entry(first, second) {
    this.first = first;
    this.second = second;
  }
  /**
   * @inheritDoc
   */


  Entry.prototype.equals = function (obj) {
    return comparators_1.equal_to(this.first, obj.first);
  };
  /**
   * @inheritDoc
   */


  Entry.prototype.less = function (obj) {
    return comparators_1.less(this.first, obj.first);
  };
  /**
   * @inheritDoc
   */


  Entry.prototype.hashCode = function () {
    return hash_1.hash(this.first);
  };

  return Entry;
}();

exports.Entry = Entry;